import { render, staticRenderFns } from "./job-detail.component.html?vue&type=template&id=0a64fb5c&scoped=true&"
import script from "./job-detail.component.ts?vue&type=script&lang=ts&"
export * from "./job-detail.component.ts?vue&type=script&lang=ts&"
import style0 from "./job-detail.component.scss?vue&type=style&index=0&id=0a64fb5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a64fb5c",
  null
  
)

export default component.exports